export class OptionSet {
    public viewValue: string;
    public value: string;
}

export class AdvancedOptionSet {
    public viewValue: string;
    public viewValueEn: string;
    public value: string;
}